/**
 * mpSpawnPoses — sandbox spawn poses for MP matchSync entities.
 */

import { ARAM_CONFIG } from '../../domain/map/aramRules.js';
import { MP_TEST_MAP_ID } from '../../domain/map/mpTestDefaults.js';

/** Lateral fountain seat spacing so 5 units do not cancel moveTo (FID-BOT-27). */
export const MP_SEAT_X_SPREAD = 2.9;

function teamSeatIndex(players, index) {
  const team = players[index]?.team;
  let seat = 0;
  for (let i = 0; i < index; i += 1) {
    if (players[i]?.team === team) seat += 1;
  }
  return seat;
}

function isChaosTeam(team) {
  return team === 'chaos' || team === 'red';
}

/**
 * @param {string} mapId
 * @param {Array<{ team?: string }>} players
 * @param {number} index
 */
export function poseForMpPlayer(mapId, players, index) {
  const p = players[index] || {};
  const seat = teamSeatIndex(players, index);
  const chaos = isChaosTeam(p.team);

  if (mapId === MP_TEST_MAP_ID || mapId === 'aram_proving_grounds') {
    const pad = chaos
      ? ARAM_CONFIG.spawnPlatforms.red
      : ARAM_CONFIG.spawnPlatforms.blue;
    const xSpread = (seat - 2) * MP_SEAT_X_SPREAD;
    return { x: pad.x + xSpread, z: pad.z };
  }

  return { x: chaos ? 20 : -20, z: seat * 2 };
}

/** Seat a champion on sandbox xz (lane is z, y is height). */
export function applyMpSpawnPose(entity, pose) {
  if (!entity || !pose) return entity;
  entity.x = pose.x;
  entity.y = 0;
  entity.z = pose.z;
  entity.targetX = pose.x;
  entity.targetZ = pose.z;
  return entity;
}

/** Place caster beside target on sandbox xz so targeted summoners can land. */
export function seatBeside(caster, target, dist = 1) {
  if (!caster || !target) return caster;
  caster.x = target.x;
  caster.y = 0;
  caster.z = (Number.isFinite(target.z) ? target.z : 0) + dist;
  caster.targetX = caster.x;
  caster.targetZ = caster.z;
  return caster;
}
